import { LOCALES } from '../constants';

const uk = {
	[LOCALES.uk]: {
		Russian: 'Русский',
		English: 'English',
		Ukrainian: 'Українська',
		Authorization: 'Авторизація',
		Registration: 'Реєстрація',
		'Your account has been blocked': 'Ваш обліковий запис заблоковано',
		'Please contact support for assistance': 'Будь ласка, зверніться до служби підтримки',
		'Contact support': 'Зв’язатися з підтримкою',
		'Yes, change': 'Так',
		No: 'Ні',
		'Re-enter hash': 'Повторно ввести хеш',
		'Are you sure you have to re-enter the hash?': 'Ви впевнені, що вам потрібно повторно ввести хеш?',
		'Your request is being processed': 'Ваш запит обробляється',
		'Your unblock request has been sent to support': 'Ваш запит на розблокування надіслано до служби підтримки',
		Back: 'Назад',
		'First login attempt is failed': 'Перша спроба входу не вдалася',
		'Oops! Something went wrong. Please try again.': 'Ой! Щось пішло не так. Будь ласка, спробуйте ще раз.',
		'An error occurred': 'Сталася помилка',
		Refresh: 'Оновити',
		'QR code reading error': 'Помилка зчитування QR-коду',
		'Try again': 'Повторити',
		'Authorization failed': 'Авторизація не вдалася',
		'First login': 'Перший вхід',
		'Enter your login': 'Введіть ваш логін',
		'I agree to the': 'Я погоджуюся з',
		'Terms of Use and the Public Offer Agreement': 'Умовами використання та Договором публічної оферти',
		Continue: 'Продовжити',
		'Create new password': 'Створіть новий пароль',
		'Enter your password': 'Введіть пароль',
		'Repeat your password': 'Повторіть пароль',
		'The password must contain 6 - 64 characters, including lowercase and uppercase Latin letters and at least one number.':
			'Пароль повинен містити від 6 до 64 символів, включаючи малі та великі латинські літери, та щонайменше одну цифру.',
		'Hash or QR is invalid': 'Хеш або QR-код недійсний',
		'I Agree': 'Погоджуюсь',
		'Incorrect login': 'Неправильний логін',
		'Exceeded the number of registration attempts! Login blocked for {min} min {sec} sec':
			'Перевищено кількість спроб реєстрації.\nВи заблоковані на {min} хв {sec} сек',
		'Welcome to {br} {billingName} Wallet': 'Ласкаво просимо {br} у {billingName} гаманець',
		'Your personal crypto wallet for everyday payments and work with cryptocurrency.':
			'Ваш особистий криптогаманець для щоденних платежів та роботи з криптовалютою.',
		'Sign up': 'Реєстрація',
		'Sign in': 'Вхід',
		'Passwords are different': 'Паролі не співпадають',
		'Enter hash or scan QR code': 'Введiть хеш або вiдскануйте QR-код',
		Paste: 'Вставити',
		"Password doesn't match": 'Пароль не спiвпадає',
		Login: 'Логiн',
		'Enter your login and password': 'Введіть свій логін та пароль',
		'Login or password is incorrect': 'Неправильний логін або пароль',
		'Exceeded the number of authorization attempts! Login blocked fo {m} min {s} sec':
			'Перевищено кількість спроб авторизації!\nЛогін заблоковано на {m} хв {s} сек',
		'Crypto portfolio': 'Портфоліо',
		Send: 'Надіслати',
		Receive: 'Отримати',
		Sent: 'Надіслано',
		Received: 'Отримано',
		Assets: 'Активи',
		History: 'Історія',
		Address: 'Адреса',
		Addresses: 'Адреси',
		'All addresses': 'Усі адреси',
		Account: 'Акаунт',
		Hash: 'Хеш',
		Password: 'Пароль',
		Success: 'Успіх',
		Cancel: 'Скасування',
		'Your password': 'Ваш пароль',
		'Scan the QR code': 'Відскануйте QR-коду',
		'Point your camera at the QR code with the address.': 'Наведіть камеру на QR-код з адресою.',
		'Upload QR code': 'Завантажити QR-код',
		'Select asset': 'Оберіть актив',
		'Select address': 'Оберіть адресу',
		'Enter payment details': 'Введіть платіжні дані',
		'Confirm payment': 'Підтвердіть платіж',
		'This address does not belong to the blockchain {currency}': 'Ця адреса не належить блокчейну {currency}',
		'The minimum withdrawal amount is {amount} {currency}': 'Мінімальна сума переказу складає {amount} {currency}',
		'The amount exceeds the balance on the address': 'Сума переказу перевищує залишок на адресі',
		Send_v2: 'Надіслати',
		Send_v3: 'Переказати',
		Step: 'Крок {number}',
		'Enter payment information': 'Додайте платіжну інформацію',
		'Recipient address': 'Адреса одержувача',
		'Type recipient address': 'Введіть адресу одержувача',
		'Transaction fee': 'Комісія за транзакцію',
		'Learn about transaction fees': 'Дізнайтесь про комісію за транзакцію',
		'This is the fee paid to the blockchain to process your transaction. Transaction speed depends on the fee amount: higher fees are usually confirmed faster':
			'Це сума, яка виплачується блокчейну за обробку вашої транзакції. Швидкість підтвердження залежить від розміру комісії: зазвичай більша комісія призводить до швидшого підтвердження.',
		'Use a single transaction for inputs': `Використовувати одну транзакцію для входів`,
		'All inputs will be combined into one transaction. This can lower the total fee but increases the chance that those addresses will be linked on the blockchain.':
			"Усі входи будуть зібрані в одну транзакцію. Це може зменшити загальну комісію, але підвищує ймовірність пов'язування цих адрес у блокчейні.",
		'Note: combining inputs within a single transaction may result in visible linkage between addresses at the blockchain level. Consider this when choosing how inputs are processed.':
			'Примітка: об’єднання входів у межах однієї транзакції може призвести до видимого зв’язку між адресами на рівні блокчейна. Враховуйте це під час вибору способу обробки входів.',
		'Got it': 'Зрозуміло',
		Amount: 'Сума переказу',
		Available: 'Баланс',
		'Send max': 'Вставити все',
		'Fee amount': 'Комісія',
		'Show more': 'Показати ще',
		Fee: 'Комісія',
		Comment: 'Коментар',
		Success_v2: 'Успішно',
		Comments: 'Коментар',
		'Transaction details': 'Деталі транзакції',
		'View on block explorer': 'Відкрити в блокчейн-експлорері',
		'only you can see': 'видно тільки вам',
		Optional: 'Опціонально',
		Amount_v2: 'Сума',
		'To be withdraw': 'Буде знято',
		'To be receive by recipient': 'Отримає одержувач',
		'Sender address': 'Адреса відправника',
		'Fee details': 'Комісія',
		'Fee from': 'Комісія з',
		'Fee amount_v2': 'Сума комісії',
		Confirm: 'Пiдтвердити',
		Details: 'Деталі',
		None: 'Вiдсутнiй',
		Queued: 'В черзі',
		Completed: 'Виконано',
		Failed: 'Неуспiшно',
		Processing: 'В обробці',
		'Waiting confirmation': 'Очікування підтвердження',
		Cancelled: 'Скасовано',
		'To be withdraw_v2': 'Було знято',
		'To be receive by recipient_v2': 'Отримав одержувач',
		Date: 'Дата',
		Status: 'Статус',
		Copy: 'Скопіювати',
		Share: 'Поділитися',
		Information: 'Інформація',
		'View on Tronscan': 'Переглянути на Tronscan',
		'View on Etherscan': 'Переглянути на Etherscan',
		'Send only {currency} to this address on the {network} network, otherwise you may lose your funds.':
			'Надсилайте лише {currency} на цю адресу в мережі {network}, інакше ви можете втратити свої кошти.',
		'Share your QR code': 'Поділіться QR-кодом',
		Asset: 'Актив',
		Network: 'Мережа',
		'Use {currency} and save money': 'Використовуйте {currency} та заощаджуйте',
		'Learn more': 'Дізнатися більше',
		'Select an asset for payment': 'Виберіть атив для оплати',
		'A minimum of 35 TRX is required for guaranteed withdrawal. The real cost depends on the payment and takes a smaller amount':
			'Для гарантованої відправки транзакції треба не меньше на 35 TRX. Фактичні витрати залежать від платежу і становитимуть меншу сумму.',
		Error: 'Помилка',
		'Address copied': 'Адресу скопійовано',
		'Hash copied': 'Хеш скопійовано',
		'There are no transactions yet': 'Транзакцій поки що немає',
		'Transaction fee will be calculated automatically': 'Комісія транзакціі буде розрахована автоматично',
		'In progress': 'В обробці',
		'You cannot send funds to the same address': 'Не можна переказувати кошти на ту саму адресу',
		'Error in calculating withdrawal fees': 'Помилка розрахунку комiсiї виведення коштiв',
		'Error in preparing withdrawal data': 'Помилка при пiдготовцi даних виведення коштiв',
		'Withdrawal transaction successfully created': 'Транзакцiя виводу коштiв успiшно створена',
		'Error confirmating the withdrawal': 'Помилка пiд час пiдтвердження виведення коштiв',
		'Salary wallet': 'Зарплатний гаманець',
		'Not enough TRX to create transaction': 'Недостатньо TRX для виконання транзакцiї',
		'Enter your Pin-code': 'Введіть ваш пiн-код',
		'Pin-code is incorrect. Try again': 'Пiн-код невiрний. Спробуйте ще',
		'Create PIN-code': 'Створити пін-код',
		'Confirm PIN-code': 'Підтвердити пін-код',
		'Pin-code will be used to confirm transactions.': 'Пiн-код буде використаний для пiдтвердження транзакцій',
		"Pin-code doesn't match. Try again": 'Пiн-код не збiгається. Спробуйте ще',
		"Error! You're trying to login to Mobile account from wrong Telegram":
			'Помилка! Ви намагаєтеся зайти в акаунт Мобайл не з того облiкового запису Telegram',
		'The previous transaction is being processed. Please wait for confirmation before creating the next one.':
			'Попередня транзакцiя в обробцi. Будь ласка, зачекайте на пiдтвердження, перш нiж створювати наступну.',
		'Top up': 'Поповнити',
		'Top up2': 'Поповнення',
		'How to use {currency}': 'Як використовувати {currency}',
		'{currency} are internal units for use only within {productName}. They cannot be withdrawn or converted. Value: 1 {currency} = 1 USD.':
			'{currency} — це внутрішня одиниця, що використовується виключно в системі {productName}. Вони не підлягають виведенню або конвертації. Вартість: 1 {currency} = 1 USD.',
		'Pay fees': 'Оплата комiсiй',
		'TRON fees can be paid using {currency}, simplifying fee management for outgoing transactions.':
			'Комісії в мережі TRON можна сплачувати за допомогою {currency}, що спрощує керування комісіями для вихідних операцій.',
		'Read more': 'Докладніше',
		'My address': 'Моя адреса',
		'No transactions yet': 'Поки немає транзакцій',
		"You don't have any assets available to receive yet.": 'У вас поки немає доступних активів для отримання.',

		'Risk level': 'Рівні ризику',

		'AML check': 'AML-перевірка',
		'Address for AML check': 'Адреса для AML-перевірки',
		'Auto-detected. Select manually if needed.': 'Визначається автоматично. За потреби можна вибрати вручну.',
		'The network could not be detected automatically.\nPlease select the network manually.':
			'Не вдалося автоматично визначити мережу.\nБудь ласка, виберіть мережу вручну.',
		Reset: 'Скинути',
		'Insufficient balance for this payment methods.': 'Недостатньо коштів для цього способу оплати.',
		'Price per check': 'Вартість перевірки',
		'AML check V2': 'Запустити AML-перевірку',
		'Scan address': 'Сканувати адресу',
		'Low risk': 'Низький ризик',
		'Medium risk': 'Середній ризик',
		'High risk': 'Високий ризик',
		'Outdated risk': 'Застарілий ризик',
		'Unchecked risk': 'Неперевірений ризик',
		'Check AML risk': 'Перевірити AML-ризик',
		'In progress V2': 'У процесі',
		'AML Details': 'Деталі AML',
		'Source of funds': 'Джерело коштів',
		'Use of funds': 'Використання коштів',
		Category: 'Категорія',
		'Share V2': 'Частка',
		'Recheck address': 'Повторно перевірити адресу',
		Counterparties: 'Контрагенти',
		Transactions: 'Транзакції',
		'All balance': 'Весь баланс',
		'Last check': 'Перевірено',
		'Part of the funds associated with high-risk sources.': 'Частина коштів, пов’язана з джерелами високого ризику.',
		'All connections': 'Усі підключення',
		'Source of funds Avg. risk (%)': 'Джерело коштів\nСеред. ризик (%)',
		'Use of funds Avg. risk (%)': 'Використання коштів\nСеред. ризик (%)',
		'How funds are categorized by risk level based on their origin and the destinations they were sent to.':
			'Як кошти класифікуються за рівнем ризику залежно від їхнього походження та адрес, на які вони були відправлені.',
		Low: 'Низький',
		Medium: 'Середній',
		High: 'Високий',
		Settled: 'Settled',
		Uncategorized: 'Без категорії',

		'High-risk % shows the portion of funds associated with high-risk sources.':
			'% Високого ризику показує частину коштів, пов’язаних із джерелами підвищеного ризику.',
		'This percentage reflects the combined contribution of funds linked to sources classified as high risk, such as sanctions, scams, stolen funds, terrorism financing, and other suspicious activities.\nA higher value does not represent the overall AML risk level of the address. It indicates that part of the funds originates from high-risk sources and may require additional attention during compliance checks.':
			'Цей відсоток відображає сукупну частку коштів, пов’язаних із джерелами, класифікованими як високоризикові — такими як санкції, шахрайство, викрадені кошти, фінансування тероризму та інша підозріла активність.\nВище значення не означає загальний рівень AML-ризику адреси. Воно вказує на те, що частина коштів походить із джерел підвищеного ризику та може потребувати додаткової уваги під час перевірки.',
		'Review the AML details to understand the source and use of funds.\nUse this information to make an informed decision before interacting with these assets.':
			'Перегляньте детальні AML-дані, щоб зрозуміти джерело та використання коштів.\nВикористовуйте цю інформацію для прийняття зваженого рішення перед взаємодією з цими активами.',

		'This AML result may no longer reflect the current state of the address.\nWe recommend running a new AML check to get up-to-date information.':
			'Результат AML-перевірки може більше не відображати поточний стан адреси.\nРекомендуємо запустити нову AML-перевірку, щоб отримати актуальну інформацію.',

		'Why this address has no AML result yet': 'Чому для адреси ще немає результату AML',
		'This address has not been checked for AML risks yet.': 'Ця адреса ще не проходила перевірку на AML-ризики.',
		'There is not enough data to assess the risk level of this address at the moment.\nAn unchecked status does not indicate low or high risk — it means the risk has not been evaluated.':
			'Наразі недостатньо даних для оцінки рівня ризику цієї адреси.\nСтатус «не перевірено» не означає низький або високий ризик — це означає, що ризик ще не оцінювався.',
		'Run an AML check to check the address, calculate its risk score, and view detailed information about the source and use of funds.':
			'Запустіть AML-перевірку, щоб перевірити адресу, розрахувати її рівень ризику та переглянути детальну інформацію про джерело й використання коштів.',

		'AML Risk': 'AML-ризик',
		'How AML risk is calculated': 'Як розраховується AML-ризик',

		'AML check is in progress.': 'AML-перевірка виконується.',
		'This may take some time. You can continue using the wallet as usual.\nYou will be notified once the check is complete.':
			'Це може зайняти деякий час. Ви можете продовжувати користуватися гаманцем у звичному режимі.\nПісля завершення перевірки ви отримаєте сповіщення.',

		'This address has not been AML-checked yet.\nPlease run an AML check before sending funds.':
			'Ця адреса ще не проходила AML-перевірку.\nБудь ласка, виконайте AML-перевірку перед відправленням коштів.',
		'Check address now': 'Перевірити адресу',
		'Estimated time': 'Орієнтовний час',

		'Cover fees for outgoing transactions and save up to 50%.':
			'Оплачуйте комiсiї за вихiднi транзакцiї та заощаджуйте до 50%.',
		'Cover network fees for outgoing transactions using {currency}.':
			'Сплачуйте мережеві комісії за вихідні транзакції з використанням {currency}.',
		'Pay for AML checks': 'Оплата AML-перевiрок',
		'AML checks reveal the origin of funds and protect you from asset blocking or freezing. Run a check now -  peace of mind is priceless!':
			'AML-перевiрка визначає походження коштів і допомагає уникнути блокувань та заморожування активів. Зробіть перевірку зараз - ваш спокій того вартий!',
		'Coming soon': 'Незабаром буде доступно',
		'Add address': 'Додати адресу',
		'Give a name': 'Укажіть назву',
		'Enter a title to easily identify this address.': 'Введіть назву, щоб простіше розрізняти адреси.',
		"Stay tuned for updates and don't miss new features as they roll out":
			'Слідкуйте за оновленнями й не пропустіть нові можливості.',
		'Fee payment': 'Оплата комісіі',
		Expence: 'Витрати',
		'{billingName} USD Mobile Balance': '{billingName} USD Мобільний Баланс',
		'{billingName} Mobile balance is needed to pay for Mobile Wallet services...':
			'Баланс {billingName} Mobile потрібен для оплати послуг Мобільного гаманця...',
		'More about services': 'Детальніше про послуги',
		'Your balance': 'Ваш баланс',
		'Buy {currency}': 'Купити {currency}',
		'About {currency}': 'Про {currency}',
		'What is {currency} for': 'Для чого потрібні {currency}',
		'{currency} usage options': 'Можливості використання {currency}',
		'Commission payment': 'Оплата комісій',
		"You can pay outgoing transaction fees with up to 50% discount using BH USD.\nTry it — it's easy!":
			'Ви можете оплачувати комісію за вихідні транзакції зі знижкою до 50% з рахунку BH USD.\nСпробуйте — це просто!',
		'AML check payment': 'Оплата AML перевірок',
		'AML checks provide risk assessment information required for compliance procedures. \nInitiate an AML check to obtain risk assessment information.':
			'AML-перевірки надають інформацію про рівень ризику, необхідну для дотримання процедур комплаєнсу.\nІніціюйте AML-перевірку для отримання інформації про рівень ризику.',
		'To be announced': 'Буде оголошено пізніше',
		'Not enough balance': 'Недостатньо коштів на балансі',
		'Fee amount_v3': 'Розмір комісії',
		Balance: 'Баланс',
		'Choose fee payment method': 'Виберіть спосіб оплати',
		'Choose fee payment method. The cost varies depending on the option chosen.':
			'Виберіть спосіб оплати. Вартість залежить від обраного варіанту.',
		'Password and Pin-code have been created': 'Пароль та PIN-код створено',
		'Fee payment method': 'Спосіб оплати комісії',
		'Amount to pay': 'Сума до оплати',
		'Select payment address': 'Оберiть адресу для оплати',
		Period: 'Період',
		'Last week': 'Останній тиждень',
		'Last month': 'Останній місяць',
		'Last year': 'Останній рік',
		'Insufficient balance to pay the commission': 'Недостатньо балансу для оплати комісії',
		'Loading error!': 'Помилка завантаження!',
		Custom: 'Налаштувати',
		'Select period': 'Вибрати перiод',
		'Start date': 'Дата початку',
		'end date': 'дата кiнця',
		'Enter your login and password to verify your identity': 'Введіть свій логін і пароль, щоб підтвердити свою особу',
		'PIN-code recovery': 'Відновлення PIN-коду',
		'Forgot password?': 'Забули пароль?',
		'Create a PIN code that will be used to log in and confirm transactions.':
			'Створіть PIN-код, який використовуватиметься для входу та підтвердження транзакцій.',
		'PIN-code has been restored': 'Пін-код відновлено',
		'All transactions': 'Усі транзакції',
		Today_uppercase: 'СЬОГОДНІ',
		Yesterday_uppercase: 'ВЧОРА',
		'All wallets': 'Усі гаманці',
		'No assets yet': 'Активів поки немає',
		"They'll appear here soon": "Вони з'являться тут пізніше",

		Add: 'Додати',
		'Add to Home Screen': 'Додати на головний екран',
		'Add {productName} to Home Screen': 'Додайте {productName} на домашній екран',
		'Tap the {icon} button at the bottom': 'Натисніть кнопку {icon} внизу екрана',
		'Select {icon} <p>to Home Screen</p>': 'Виберіть {icon} <p>«На домашній екран»</p>',

		'Select network': 'Вибір мережі',

		'Password recovery': 'Відновлення пароля',
		'The only way to recover your wallet is to complete the recovery procedure through Support':
			'Єдиний спосіб відновити ваш гаманець — це пройти процедуру відновлення через службу підтримки',
		'Send a request and follow the instructions provided in {supportBotName}':
			'Надішліть запит і дотримуйтесь інструкцій, наведених у {supportBotName}',
		'Send a request': 'Надішліть запит',
		More: 'Більше',
		'Send only {coinName} to this address. Sending any other assets may result in permanent loss.':
			'Надсилайте на цю адресу лише {coinName}. Надсилання інших активів може призвести до їхньої втрати.',
		'Please note: Once the PIN-code is changed, withdrawal will be disabled for {time}.':
			'Зверніть увагу: після зміни PIN-коду виведення коштів буде недоступне протягом {time}.',
		Mo: 'Пн',
		Tu: 'Вт',
		We: 'Ср',
		Th: 'Чт',
		Fr: 'Пт',
		Sa: 'Сб',
		Su: 'Нд',
		Apply: 'Застосувати',
		'{currency} needs to be topped up': 'Треба поповнити {currency}',
		'Copy error code': 'Скопіювати код помилки',
		Copied: 'Скопійовано',
		'Pick a username that hasn’t been taken yet or enter your invite. You can use letters, numbers, dots, and underscores.':
			"Виберіть вільне ім'я користувача або введіть своє запрошення. Ви можете використовувати літери, цифри, крапки та підкреслення.",
		'Enter username or invite name': 'Введіть логiн або запрошення',
		'Terms of Use': 'Умовами використання',
		'I understand that I can only access this wallet using the account I registered with.':
			'Я розумію, що можу отримати доступ до цього гаманця лише з використанням облікового запису, з яким проходив реєстрацію.',
		'Create password': 'Створити пароль',
		'Create a password for account recovery. IMPORTANT: keep this password safe, and DO NOT lose it':
			'Створіть пароль для відновлення облікового запису. ВАЖЛИВО: зберігайте цей пароль у безпеці та НЕ втрачайте його',
		'The password must contain from {fromNumber} - {toNumber} characters, including lowercase and uppercase Latin letters and at least one number':
			'Пароль повинен містити від {fromNumber} до {toNumber} символів, включаючи малі та великі латинські літери та принаймні одну цифру',
		'Password must contain at least {number} characters': 'Пароль має містити щонайменше {number} символів',
		'Enter your username and PIN-code': "Введіть ваше ім'я користувача та PIN-код",
		'Forgot PIN-code?': 'Забули пін-код?',
		'Welcome back, {username}': 'Ласкаво просимо назад, {username}',
		Swap: 'Обмін',
		Buy: 'Покупка',
		'Recent transactions': 'Нещодавні транзакції',
		'View all': 'Переглянути всі',
		'Swap is currently unavailable, but we are working on getting it up and running':
			'Обмін наразі недоступний, але ми працюємо над його запуском',
		'Buy is currently unavailable, but we are working on getting it up and running.':
			'Покупка в даний час недоступна, але ми працюємо над її запуском',
		"You don't have any assets to send. Please top up your balance.":
			'У вас немає активiв для переказу. Будь ласка, поповніть баланс',
		'Empty page': 'Пустая страница',
		'There is nothing on this page': 'На цiй сторiнцi нiчого немає',
		'Username must contain at least {number} characters': "Iм'я користувача має мiстити щонаймене {number} символiв",
		'Enter PIN-code': 'Введiть пiн-код',
		'You PIN-code is required to authenticate secure actions': 'Ваш пiн-код потрiбний для автентифiкацiї захищених дiй',
		'Select asset to send': 'Виберiть актив для надсилання',
		'Select asset to receive': 'Виберiть актив для отримання',
		"You don't have transactions": 'У вас немає транзакцiй',
		'No addresses yet': 'Адрес поки немає',
		'Enter address': 'Ввести адресу',
		To: 'Кому',
		Next: 'Далі',
		'Please wait': 'Зачекайте',
		'The address incorrect': 'Адреса невірна',
		'You’ve already sent USDT. A new transfer will be available once the current transaction is completed.':
			'Ви вже надіслали USDT. Новий переказ буде доступний після завершення поточної транзакції.',
		Done: 'Готово',
		Max: 'Max',
		'Network fee': 'Мережева комісія',
		'Best price': 'Найкраща ціна',
		'Benefit up to': 'Вигода до',
		'Confirm transaction': 'Підтвердити транзакцію',
		'Amount to send': 'Сума до переказу',
		'Network fee_v2': 'Комісія мережі',
		From: 'Від',
		Available_v2: 'Доступно',
		'Insufficient balance for this method.': 'Недостатньо коштiв для оплати цим методом.',
		'Attention: The transaction is already in progress from this address.':
			'Увага: З цiєї адреси вже виконується транзакцiя.',
		Successful: 'Успiшно',
		'The transaction has been sent.': 'Транзакцiя надiслана.',
		'Your payment is being processed.': 'Ваш платiж обробляється.',
		'Processing may take some time and involve multiple technical transactions, all of which will be recorded in the transaction history.':
			'Обробка може зайняти певний час і включати кілька технічних транзакцій, які відображатимуться в історії операцій.',
		'Only "A-Z", "a-z", "0-9", "_", "." or "-" allowed': 'Тiльки "A-Z", "0-9", "_", "." чи "-" допустимо',
		Attention: 'Увага',
		'Enter amount': 'Введiть суму',
		'Select asset to pay': 'Виберiть актив для оплати',
		'Select address to pay': 'Виберiть адресу для оплати',
		'Password is not valid': 'Некоректний пароль',
		'Enter the characters you see': 'Введіть символи з картинки',
		'Can’t read?': 'Не видно?',
		'Enter the CAPTCHA code': 'Введіть код CAPTCHA',
		Submit: 'Відправити',
		'Invalid code.': 'Невірний код.',
		'Please try again.': 'Будь ласка, спробуйте ще раз.',
		'Creating wallet addresses…': 'Створення адрес гаманця…',
		'Not enough funds to cover the fee': 'Недостатньо коштів для оплати комісії',
		'Not enough {currency} funds to cover the fee': 'Недостатньо {currency} коштів для оплати комісії',
		'With this fee, confirmation may take longer than usual.':
			'З цією комісією підтвердження може тривати довше, ніж зазвичай.',
		'Transaction cannot be confirmed with this fee.': 'Транзакцiю неможливо пiдтвердити з такою комiсiєю.',
		'Verification required': 'Потрібна перевірка',
		'This wallet is already active on another device. To continue using it here, please verify your identity':
			'Цей гаманець уже активований на іншому пристрої. Щоб продовжити роботу тут, підтвердьте свою особу',
		'Verify identity': 'Підтвердити особу',
		'Verification successful': 'Перевірка успішна',
		'Welcome back!': 'З поверненням!',
		'Confirm login': 'Підтвердьте вхід',
		'Enter your password to continue': 'Введіть пароль, щоб продовжити',
		'The bot wasn’t created': 'Бот не був створений',
		Devices: 'Пристрої',
		'Use your account on multiple devices': 'Використовуйте акаунт на кількох пристроях',
		'This device': 'Цей пристрій',
		Online: 'У мережі',
		'Terminate all other sessions': 'Завершити інші сеанси',
		'Logs out all devices except for this one.': 'Завершить сеанси на всіх пристроях, крім поточного.',
		'Active sessions': 'Активні сеанси',
		'Enter PIN': 'Введіть PIN',
		'PIN is required to confirm this action': 'Для підтвердження дії введіть PIN',
		Language: 'Мова',
		'Interface language': 'Мова інтерфейсу',
		'Estimated blockchain fee maximum. You are only charged the actual network fee at the moment of confirmation.':
			'Максимальна оцінка комісії блокчейну. З вас стягується лише фактична комісія мережі на момент підтвердження.',
		'AML risk indicates the potential exposure of funds to illicit or high-risk activity.':
			'AML-ризик показує потенційний зв’язок коштів із незаконною або високоризиковою діяльністю.',
		'What does this mean?': 'Що це означає?',
		'The risk level is calculated based on transaction history and connections to various sources and counterparties.':
			'Рівень ризику розраховується на основі історії транзакцій і зв’язків із різними джерелами та контрагентами.',
		'It helps identify whether funds may be associated with sanctions, fraud, illegal services, or other risky activity.':
			'Він допомагає виявити можливий зв’язок коштів із санкціями, шахрайством, нелегальними сервісами та іншою ризикованою діяльністю.',
		'What should you do?': 'Що робити?',
		'Use AML risk as a reference when interacting with addresses.':
			'Використовуйте AML-ризик як орієнтир під час взаємодії з адресами.',
		'Review detailed AML information to better understand the nature and origin of funds.':
			'Переглядайте детальну AML-інформацію, щоб краще зрозуміти походження та характер коштів.',
		'No AML checks yet. Run an AML check to review potential risks for this address.':
			'AML-перевірки ще не виконувалися. Запустіть AML-перевірку, щоб оцінити можливі ризики для цієї адреси.',
		'Learn more v2': 'Докладніше',
		'Recent AML checks': 'Останні AML-перевірки',
		'View all v2': 'Переглянути всі',
		'Payment purpose': 'Призначення платежу',
		'Attached files': 'Прикріплені файли',
		'Files attached to this payment': 'Файли, прикріплені до цього платежу',
		'Access restricted': 'Доступ обмежено',
		'Your current location is included in the list of restricted countries configured by the Administrator (root).':
			'Ваша поточна локацiя входить до списку заборонених країн, який налаштовано Адмiнiстратором (root).',
		'Upload files': 'Завантаження файлів',
		'Maximum file size: 10 MB': 'Максимальний розмір файлу: 10 МБ',
		'Attach supporting files for this payment': 'Додайте файли, що підтверджують платіж',
		'Attach files': 'Прикріпити файли',
		Type: 'Тип',
		'More details': 'Докладніше',
		'Something went wrong while checking the address. Please try again or come back later.':
			'Під час перевірки адреси щось пішло не так. Спробуйте повторити спробу або повернутися пізніше.',
		'AML check history': 'Історія AML-перевірок',
		m: 'хв',
		s: 'с',
		'Address already checked': 'Адреса вже перевірена',
		'The AML check request was canceled because this address already has a valid and up-to-date AML result.':
			'Запит на AML-перевірку було скасовано, оскільки для цієї адреси вже є актуальний результат AML-перевірки.',
		'To proceed, you must provide a payment purpose or attach a supporting file.':
			'Для продовження необхідно зазначити призначення платежу або додати підтвердний файл.',
		Unverified: 'Немає даних',
		'This address hasnt appeared in any known AML records — flagged or otherwise.':
			'Адреса не помічена в жодній AML-базі: ні серед підозрілих, ні серед довірених.',
		'No risk data available — this address has no recorded activity.':
			'Дані про ризики відсутні — активність за адресою не зафіксована.',
		'The address does not match the selected network': 'Адрес не відповідає обраній мережі',
		'Choose the correct blockchain.': 'Виберіть правильний блокчейн.',
	},
};

export default uk;
